var exports = {
  "K": "xe7b6e3d6--7bbd34--icon",
  "N": "xe7b6e3d6--7bbd34--icon--opened",
};

module.exports = exports;
